import React, { useCallback, useRef, useState, useEffect } from "react";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, Col } from "react-bootstrap";
import { UsersGroupTable } from "../allTables/allTable";
import { useFormik } from "formik";
import GroupService from "../../services/group.service";
import { CSVLink } from "react-csv";
import { enqueueSnackbar } from "notistack";
import { HashLoader } from "react-spinners";
import { useLocation } from "react-router-dom";

const Groups = () => {
  const location = useLocation();
  const selectedType = location.search.split("=")[1];
  const [groupData, setGroupData] = useState([]);
  const [totalGroups, setTotalGroups] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState("");
  const [search, setSearch] = useState("");
  const [isAllGroupData, setIsAllGroupData] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const csvLinkRef = useRef(null);
  const [shouldDownload, setShouldDownload] = useState(false);

  const getAllGroups = async () => {
    setIsLoading(true)
    try {
      const response = await GroupService.getAllGroupsList(
        search,
        pageNumber,
        dataPerPage
      );
      setGroupData(response?.data?.data);
      setTotalGroups(response?.data?.total);
      setTotalRows(response.data.total);
    } catch (error) {
      console.error("error", error);
    } finally{
      setIsLoading(false)
    }
  };

  const handleData = (e) => {
    setSearch(e.target.value);
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllGroups();
  }, [pageNumber, dataPerPage, search, selectedType]);

  const initialValue = {
    data: "",
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: "schema",
  });

  const headers = [
    { label: "Group Code", key: "groupCode" },
    { label: "Member Code", key: "useUniqueCode" },
  ];

  const onclickExportGroup = useCallback(async () => {
    setButtonLoading(true);
    try {
      const response = await GroupService.getAllGroupsList("", "", "");
  
      await setIsAllGroupData(response?.data?.data);
      setShouldDownload(true); // Set flag to trigger download
    } catch (error) {
      console.error("Export error:", error);
      enqueueSnackbar("Failed to export groups. Please try again.", {
        variant: "error",
      });
    } finally {
      setButtonLoading(false);
    }
  }, []);

  // This effect will trigger the download when shouldDownload is true and data is available
  useEffect(() => {
    if (shouldDownload && isAllGroupData?.length > 0) {
      const csvButton = document.getElementById("csv-download-btn");
      if (csvButton) {
        csvButton.click();
      }
      setShouldDownload(false); // Reset the flag after download
    }
  }, [shouldDownload, isAllGroupData]);

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Groups
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fas fa-solid fa-layer-group icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalGroups}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={6} className="ms-auto mt-auto">
          <div
            className="custom-card text-end pointer"
            style={{ marginRight: "18px" }}>
            <Button
              className="text-white"
              onClick={onclickExportGroup}
              disabled={buttonLoading || groupData?.length === 0}
              style={{
                marginBottom: "5px",
                marginLeft: "15px",
                width: "150px",
              }}>
              {buttonLoading ? (
                <div className="spinner-container">
                  <HashLoader color="#ffffff" size={30} loading={true} />
                </div>
              ) : (
                <>
                  <i className="fas fa-download"></i> Export Groups
                </>
              )}
            </Button>

            <CSVLink
              id="csv-download-btn"
              data={isAllGroupData?.reduce((acc, item) => {
                const groupCode = item.groupCode || "";
                const members = item.members || [];
                const hasFirstName = members.some(
                  (member) => member.firstName
                );

                if (!hasFirstName) {
                  return [...acc, { groupCode, useUniqueCode: "-" }];
                }
                return [
                  ...acc,
                  ...members.map((member) => ({
                    groupCode: groupCode ?? "=",
                    useUniqueCode: member.useUniqueCode ?? "-",
                  })),
                ];
              }, [])}
              headers={headers}
              filename={`All_Groups.csv`}
              style={{ display: "none" }}
              ref={csvLinkRef}
            />
          </div>
        </Col>
      </div>
      <UsersGroupTable
        data={groupData}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        dataPerPage={dataPerPage}
        isLoading={isLoading}
        handleData={handleData}
        setDataPerPage={setDataPerPage}
        getAllGroups={getAllGroups}
      />
    </>
  );
};

export default Groups;